import { ENDPOINTS, ENDPOINTS_ERP } from "./enpoints";
import { createAPIEndpoint } from "./authenticated.requests";
import { createERPApiEndpoint } from "./authenticated.erp.requests";
export const APi = {
  ENDPOINTS,
  createAPIEndpoint,
};

export const ERP_APi = {
  ENDPOINTS_ERP,
  createERPApiEndpoint,
};
